import React, { useState, useEffect, useCallback } from 'react';
import PieChartPaddingComponent from '../../../components/Charts/PieChartWithPaddingAngle';
import EmptyState from '../../../components/EmptyState';
import { useNavigate } from 'react-router-dom';
import { getNumbersWithDecimalPlaces } from '../../../utilities/money';

const ChainSplit = (props) => {
  const navigate = useNavigate();

  const { chain_total_amounts, title } = props;
  const [chainSplit, setChainSplit] = useState([]);
  const handleNavigate = () => {
    if (props.individualPage) {
      props.navigatedTab(3);
    } else {
      navigate('/assets');
    }
  };

  const chainSplitCalculator = useCallback(() => {
    if (!chain_total_amounts) return [];
    let chainSplit = Object.keys(chain_total_amounts).map((key) => {
      if (chain_total_amounts[key] && chain_total_amounts[key] >= 0) {
        return { name: key.toUpperCase(), value: chain_total_amounts[key], chain: key };
      } else {
        return { name: key.toUpperCase(), value: chain_total_amounts[key], chain: key };
      }
    });

    const totalValueOfAllChain = chainSplit
      .map((chain) => chain.value)
      .reduce((partialSum, currentValue) => partialSum + currentValue, 0);

    let chainSplitByPercentage = chainSplit
      .map((eachChainSplit) => {
        let percentageAllocation = (eachChainSplit.value / totalValueOfAllChain) * 100;
        return {
          name: `${eachChainSplit.name} ${getNumbersWithDecimalPlaces(percentageAllocation, 5)} %`,
          value: eachChainSplit.value,
          chain: eachChainSplit.chain,
        };
      })
      .filter((chain_split) => chain_split.value > 0);

    /**
     * Sorting the values by descending order according to value
     */
    chainSplitByPercentage.sort((a, b) => {
      return b.value - a.value;
    });
    /**
     * Only showing 7 highest chain
     */
    chainSplitByPercentage = chainSplitByPercentage.slice(0, 7);
    setChainSplit(chainSplitByPercentage);
  }, [chain_total_amounts]);

  useEffect(() => {
    chainSplitCalculator();
  }, [chainSplitCalculator]);
  return (
    <>
      <div className="home_card_two" style={{ height: '405px' }}>
        <div style={{ height: '100%' }}>
          <div style={{ height: '100%' }}>
            <div style={{ marginBottom: '1rem' }}>
              <span className="heading_text">{title ? title : 'Chain Split'}</span>
            </div>
            {chainSplit && chainSplit.length ? (
              <PieChartPaddingComponent chartData={chainSplit} />
            ) : (
              <div className="empty_state_charts">
                {' '}
                <EmptyState />{' '}
              </div>
            )}
          </div>
        </div>
        {props.individualPage && (
          <div
            className="view-assets"
            style={{ color: '#006DCC', cursor: 'pointer' }}
            onClick={handleNavigate}
          >
            View Chain Split
          </div>
        )}
      </div>
    </>
  );
};

export default ChainSplit;
